import { createContext, useContext, useState } from 'react';

const AnalysisContext = createContext(null);

export function AnalysisProvider({ children }) {
  const [analysisData, setAnalysisData] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);

  const clearAnalysis = () => {
    setAnalysisData(null);
    setUploadedFile(null);
  };

  return (
    <AnalysisContext.Provider value={{
      analysisData, setAnalysisData,
      uploadedFile, setUploadedFile,
      clearAnalysis,
    }}>
      {children}
    </AnalysisContext.Provider>
  );
}

export function useAnalysis() {
  const context = useContext(AnalysisContext);
  if (!context) {
    throw new Error('useAnalysis deve ser usado dentro de um AnalysisProvider');
  }
  return context;
}
